
const EmailPhoneContact = () => (
  <span> please contact <a href="mailto:mygivinggateway@support.ucla.edu">MyGivingGateway@support.ucla.edu</a> or (310) 794-2447 for assistance.</span>
)

export default EmailPhoneContact;